export const PROPERTY_DECIMAL_PLACE_COUNT = 3;
export const LIMIT_DECIMAL_PLACE_COUNT = 3;
export const PROPERTY_DECIMAL_PLACE_COUNT_MAX = 6;
export const COOKIE_NAME = "connect.sid";
